const prefix = 'campuses/';

export const CAMPUSES_START = `${prefix}CAMPUSES_START`;
export const CAMPUSES_SUCCESS = `${prefix}CAMPUSES_SUCCESS`;
export const CAMPUSES_ERROR = `${prefix}CAMPUSES_ERROR`;
